import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Accordion, Col, Row } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AddButton, Button } from '@rd-web-markets/shared/dist/util/buttons';
import useConsultantRole from '@rd-web-markets/shared/dist/hooks/useConsultantRole';
import EditUserAccessModal from './EditUserAccessModal';
import { handleError } from '../../store/features/alertSlice';
import claimGroupService from '../../services/claim_group.service';
import CreateUserAccessModal from '@rd-web-markets/market/dist/claim_schedule_engagement_team/CreateUserAccessModal';
import ContactCard from './ContactCard';
import CreateAccountantCollaboratorModal from './CreateAccountantCollaboratorModal';
import { SHOULD_SHOW_ADD_USER_BUTTON_FOR_ADMINS } from '@rd-web-markets/market/dist/constants';
import userAccessService from '../../services/user_access.service';
import isPlainObject from '../../helper_functions/isPlainObject';
const ClaimScheduleEngagementTeam = _ref => {
  let {
    claimGroup,
    setClaimGroup,
    company,
    claimGroupStepAccess
  } = _ref;
  const {
    t
  } = useTranslation();
  const [userAccessToEdit, setUserAccessToEdit] = useState(null);
  const [aymingContactsOpen, setAymingContactsOpen] = useState(true);
  const [clientContactsOpen, setClientContactsOpen] = useState(true);
  const [accountantsOpen, setAccountantsOpen] = useState(true);
  const [editModalShow, setEditModalShow] = useState(false);
  const [createModalShow, setCreateModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [createAccountantCollaboratorModalShow, setCreateAccountantCollaboratorModalShow] = useState(false);
  const [getConsultantRole] = useConsultantRole();
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const createUserAccess = userAccessService.useCreateUserAccess(claimGroup, setLoading, setClaimGroup);
  const handleDelete = async userAccessId => {
    try {
      await userAccessService.delete(claimGroup.id, userAccessId);
      setClaimGroup({
        ...claimGroup,
        user_accesses: [...claimGroup.user_accesses.filter(ua => ua.id !== userAccessId)]
      });
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const editUserAccess = async userAccess => {
    setUserAccessToEdit(userAccess);
    setEditModalShow(true);
  };
  const onSubmit = async userAccess => {
    await userAccessService.update(claimGroup.id, userAccess);
    const updatedClaimGroup = await claimGroupService.get(claimGroup.id);
    setClaimGroup(updatedClaimGroup);
  };
  const shouldShowAddButton = user.account_type === 'admin' ? SHOULD_SHOW_ADD_USER_BUTTON_FOR_ADMINS : true;
  const engagementTeamClients = claimGroup.user_accesses?.filter(access => access.included_in_engagement_team === true);
  const AccorditionToggle = _ref2 => {
    let {
      title,
      setOpen,
      isOpen,
      eventKey
    } = _ref2;
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setOpen(!isOpen);
    });
    return /*#__PURE__*/React.createElement(Accordion.Button, {
      onClick: decoratedOnClick,
      as: Card.Header,
      eventKey: "0",
      className: "bg-transparent text-dark cursor-pointer border-bottom border-light d-flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordition-icon me-3"
    }, isOpen ? /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "expand_more") : /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "chevron_right")), /*#__PURE__*/React.createElement("b", null, title));
  };
  const renderAymingContacts = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
      defaultActiveKey: "0",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(AccorditionToggle, {
      title: t('ayming_contacts'),
      setOpen: setAymingContactsOpen,
      isOpen: aymingContactsOpen,
      eventKey: "0"
    }), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement(Row, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, isPlainObject(claimGroup.admin) ? /*#__PURE__*/React.createElement(ContactCard, {
      canEdit: claimGroupStepAccess.canEditAnyTypeOfUser,
      showAymingLogo: true,
      user: claimGroup.admin,
      roles: ['Manager'],
      editUserAccess: editUserAccess,
      handleDelete: handleDelete
    }) : /*#__PURE__*/React.createElement("p", {
      className: "danger"
    }, t('please_add_manager_to_company'))), claimGroup.consultant_roles.map((consultant, index) => /*#__PURE__*/React.createElement(Col, {
      md: 3,
      key: index
    }, /*#__PURE__*/React.createElement(ContactCard, {
      canEdit: claimGroupStepAccess.canEditAnyTypeOfUser,
      showAymingLogo: true,
      user: consultant.user,
      roles: [getConsultantRole(consultant.role)],
      editUserAccess: editUserAccess,
      handleDelete: handleDelete
    })))))), /*#__PURE__*/React.createElement(Accordion, {
      defaultActiveKey: "0",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(AccorditionToggle, {
      title: t('client_contacts'),
      setOpen: setClientContactsOpen,
      isOpen: clientContactsOpen,
      eventKey: "0"
    }), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
      className: "pt-2"
    }, shouldShowAddButton && /*#__PURE__*/React.createElement(AddButton, {
      isImmutableUnderReview: true,
      as: Link,
      variant: "primary",
      to: `/${user.account_type}/users/new`,
      className: "ms-auto me-3",
      text: t('add_user'),
      disabled: !claimGroupStepAccess.canEditAnyTypeOfUser
    }), /*#__PURE__*/React.createElement(AddButton, {
      isImmutableUnderReview: true,
      variant: "primary",
      onClick: () => setCreateModalShow(true),
      className: `${shouldShowAddButton ? '' : 'ms-auto '} me-3`,
      text: t('add_contact'),
      disabled: !claimGroupStepAccess.canEditAnyTypeOfUser
    })), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3"
    }, engagementTeamClients?.filter(access => access.user.account_type === 'customer').map(access => /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(ContactCard, {
      canEdit: claimGroupStepAccess.canEditAnyTypeOfUser,
      user: access.user,
      roles: access.roles,
      editUserAccess: editUserAccess,
      handleDelete: handleDelete,
      userAccess: access
    }))))))), /*#__PURE__*/React.createElement(Accordion, {
      defaultActiveKey: "0",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(AccorditionToggle, {
      title: t('accountants_collaborators'),
      setOpen: setAccountantsOpen,
      isOpen: accountantsOpen,
      eventKey: "0"
    }), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: () => setCreateAccountantCollaboratorModalShow(true),
      className: "ms-auto me-3",
      isImmutableUnderReview: true,
      disabled: !claimGroupStepAccess.canEditAnyTypeOfUser
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18 me-1"
    }, "add"), t('add_accountant_collaborator'))), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3"
    }, engagementTeamClients?.filter(access => access.user.account_type === 'accountant').map(access => /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(ContactCard, {
      canEdit: claimGroupStepAccess.canEditAnyTypeOfUser,
      user: access.user,
      roles: access.roles,
      editUserAccess: editUserAccess,
      handleDelete: handleDelete,
      userAccess: access
    }))))))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, claimGroupStepAccess.canEditAnyTypeOfUser && /*#__PURE__*/React.createElement(CreateUserAccessModal, {
    title: 'add_contact',
    onHide: () => setCreateModalShow(false),
    show: createModalShow,
    onSubmit: createUserAccess,
    company: company,
    claimGroup: claimGroup
  }), claimGroupStepAccess.canEditAnyTypeOfUser && /*#__PURE__*/React.createElement(CreateAccountantCollaboratorModal, {
    title: 'add_accountant_collaborator',
    onHide: () => setCreateAccountantCollaboratorModalShow(false),
    show: createAccountantCollaboratorModalShow,
    onSubmit: createUserAccess,
    company: company,
    claimGroup: claimGroup
  }), userAccessToEdit && claimGroupStepAccess.canEditAnyTypeOfUser && /*#__PURE__*/React.createElement(EditUserAccessModal, {
    company: company,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    title: t('edit_contact'),
    onHide: () => setEditModalShow(false),
    show: editModalShow,
    userAccess: userAccessToEdit,
    onSubmit: onSubmit
  }), renderAymingContacts());
};
export default ClaimScheduleEngagementTeam;